<script setup lang="ts">
import type Statistic from '@/views/Statistic.vue'
import { Chart as ChartJS, ArcElement } from 'chart.js'
import { computed } from 'vue'
import { Doughnut } from 'vue-chartjs'
import Typography from '../ui/typography/Typography.vue'

const props = defineProps<{
  total: number
  actions: Record<keyof typeof Statistic, number>
}>()

const data = computed(() => {
  const { best, correct, inaccuracy, wrong, blunder } = props.actions

  return {
    datasets: [
      {
        backgroundColor: ['#2AB237', '#4D9231', '#A39F27', '#B95F1E', '#AA1B1B'],
        data: [best, correct, inaccuracy, wrong, blunder]
      }
    ]
  }
})

const options = {
  cutout: '75%',
  radius: '95%',
  elements: {
    arc: {
      spacing: 10,
      borderRadius: 15,
      borderWidth: 0
    }
  }
}

ChartJS.register(ArcElement)
</script>

<template>
  <div class="w-[185px] h-[185px]">
    <Doughnut :data="data" :options="options" />
    <div class="flex flex-col items-center relative bottom-[63%]">
      <Typography class="font-semibold text-[22px]">{{ total }}</Typography>
      <Typography color="secondary" class="text-[11px]">{{
        $t('Statistic.label.Aces')
      }}</Typography>
    </div>
  </div>
</template>
